var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 20,
    fill: "white",
    stroke: "#F0F0F0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7578 28C14.8562 29.6889 15.4413 30.3968 17.704 30.3968H26.296C28.5587 30.3968 29.4606 29.0113 29.5671 27.3224L29.9935 20.5505C30.1082 18.7797 28.6981 17.2794 26.9191 17.2794C26.419 17.2794 25.9598 16.9924 25.7303 16.5497L25.14 15.3609C24.7629 14.6149 23.7791 14 22.9428 14H21.0654C20.2209 14 19.2371 14.6149 18.86 15.3609L18.2697 16.5497C18.0402 16.9924 17.581 17.2794 17.0809 17.2794C15.3019 17.2794 13.8918 18.7797 14.0065 20.5505L14.0066 22",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7705 18.9189H23.23",
    stroke: "#565656",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9994 27.1175C23.467 27.1175 24.6639 25.9206 24.6639 24.4531C24.6639 22.9855 23.467 21.7886 21.9994 21.7886C20.5319 21.7886 19.335 22.9855 19.335 24.4531C19.335 25.9206 20.5319 27.1175 21.9994 27.1175Z",
    stroke: "#565656",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.3c87a804654ecdd039d1e922d1966045.svg";
export { ForwardRef as ReactComponent };